import HomeView from '@/views/HomeView/HomeView.vue'
import DefaultHeader from '@/views/DefaultHeader/DefaultHeader.vue'
import ErrorView from '@/views/ErrorView.vue'
import RequestFixtureView from '@/views/RequestFixtureView.vue'
import { loginRedirect } from '@/hooks/authentication'
import routeNames from '@/router/names'
import * as loaded from '@/hooks/loaded'
import * as failed from '@/hooks/failed'
import routeViews from '@/router/views'
import {
  FILTER_MINE,
  FILTER_ALL,
  FILTER_CERTIFIED,
  FILTER_TRASH,
} from '@/helpers/homeFilters'
import { DEFAULT_FILTER } from '@/composables/useProfileList'
import redirectSupportSession from '@/hooks/redirectSupportSession'
import FinalizeProfileRequestForm from '@/components/ProfileRequestForms/FinalizeProfileRequestForm.vue'
import ProfileSelectionRequestForm from '@/components/ProfileRequestForms/ProfileSelectionRequestForm.vue'

export default [
  {
    path: '/',
    name: routeNames.Home,
    meta: {
      loaded: loaded.home,
      failed: failed.home,
      title: (route) => {
        const filter = route.query.filter ?? DEFAULT_FILTER
        switch (filter) {
          case FILTER_ALL:
            return 'generic.all' // TODO: Translate "All profiles"
          case FILTER_TRASH:
            return 'generic.trash'
          case FILTER_CERTIFIED:
            return 'generic.official' // TODO: Translate "Certified profiles"
          case FILTER_MINE:
            return 'generic.mine' // TODO: Translate "My profiles"
          default:
            return 'menu.profiles'
        }
      },
    },
    components: {
      [routeViews.Main]: HomeView,
      [routeViews.Header]: DefaultHeader,
    },
  },
  {
    path: '/request',
    components: {
      [routeViews.Main]: RequestFixtureView,
      [routeViews.Header]: DefaultHeader,
    },
    children: [
      {
        path: '',
        name: routeNames.Request,
        meta: {
          title: 'pb2.pageTitles.request',
          loaded: loaded.create,
          failed: failed.create,
          hideProfileBanners: true,
        },
        components: {
          [routeViews.RequestForm]: ProfileSelectionRequestForm,
        },
      },
      {
        path: 'new',
        name: routeNames.RequestNew,
        meta: {
          title: 'pb2.pageTitles.request',
          loaded: loaded.create,
          failed: failed.create,
        },
        components: {
          [routeViews.RequestForm]: FinalizeProfileRequestForm,
        },
      },
      {
        path: 'repair/:profileUid',
        name: routeNames.RequestRepair,
        meta: {
          title: 'pb2.pageTitles.request',
          loaded: loaded.repair,
          failed: failed.repair,
          hideProfileBanners: true,
        },
        components: {
          [routeViews.RequestForm]: FinalizeProfileRequestForm,
        },
      },
    ],
  },
  {
    // Route called by Regalade
    path: '/support-session/:requestId',
    name: routeNames.SupportSession,
    meta: {
      loaded: loaded.supportSession,
      failed: failed.supportSession,
      title: 'pb2.pageTitles.redirect',
    },
    component: { functional: true },
    beforeEnter: redirectSupportSession,
  },
  {
    // Route called by SSO
    path: '/redirect',
    name: routeNames.SSORedirect,
    meta: {
      bypassAuth: true,
      loaded: loaded.bypass,
      failed: failed.bypass,
      title: 'pb2.pageTitles.redirect',
    },
    component: { functional: true },
    beforeEnter: loginRedirect,
  },
  // -- 404 for * -  should be last
  {
    path: '/:pathMatch(.*)*',
    name: routeNames.Error,
    components: {
      [routeViews.Main]: ErrorView,
      [routeViews.Header]: DefaultHeader,
    },
    meta: {
      title: 'pb2.pageTitles.error',
      loaded: loaded.bypass,
      failed: failed.bypass,
      bypassAuth: true,
    },
  },
]
